<template>
  <div class="slider-wrapper">
    <div v-if="isInputChanging" class="label-container" :style="{ left: tooltipPosition }">
      <GoldcastText color="white">{{ value }}</GoldcastText>
    </div>
    <input
      type="range"
      :min="min"
      :max="max"
      :value="value"
      @input="onInput"
      @mouseenter="isInputChanging = true"
      @mouseleave="isInputChanging = false"
    />
  </div>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    value: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      isInputChanging: false
    };
  },
  computed: {
    tooltipPosition() {
      const newPosition = 10 - this.value * 0.2;
      return `calc(${this.value}% + (${newPosition}px))`;
    }
  },
  methods: {
    onInput(event) {
      this.$emit('change', event);
    }
  }
};
</script>

<style lang="scss" scoped>
.slider-wrapper {
  position: relative;
  width: 100%;

  input[type='range'] {
    margin: 20px 0;
    width: 100%;
  }
  input[type='range']:focus {
    outline: none;
  }
  input[type='range']::-webkit-slider-runnable-track {
    width: 100%;
    height: 4px;
    cursor: pointer;
    border-radius: 25px;
  }
  input[type='range']::-webkit-slider-thumb {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    cursor: pointer;
    margin-top: -6px;
  }

  .label-container {
    position: absolute;
    top: -20px;
    transform: translateY(-20%) translateY(-2px) translateX(-50%) rotate(45deg);
    background-color: #0075ff;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    width: 32px;
    height: 32px;
    border-radius: 50% 50% 0;
    bottom: 100%;
    user-select: none;

    & > * {
      transform: rotate(-45deg);
    }
  }
}
</style>
